// extracted by mini-css-extract-plugin
export var iconContainer = "_bv-0";
export var metricCardsContainer = "_bv-1";